<!-- spinner component -->
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" [size]="size" class="nv-spinner" [type]="icon" [fullScreen]="fullScreen" [name]="name" [showSpinner]="_show === true">
    <p *ngIf="viewText">{{ loadingText }}</p>
</ngx-spinner>
